import app from '@/app';
import angular from 'angular';

/* @ngInject */
function UnitPriceTable($resource, DateUtils) {
	return $resource(
		'api/unit-price-tables/:id',
		{ id: '@id' },
		{
			create: { method: 'POST' },
			query: { method: 'GET' },
			all: { method: 'GET', params: { id: 'all' }, isArray: true },
			update: { method: 'PUT' }
		}
	);
}

app.factory('UnitPriceTable', UnitPriceTable);
